import {
    TRV_CTA_BUTTON, TRV_CTA_SUBTITLE, TRV_CTA_TITLE,
    TRV_DEST_CARIBBEAN, TRV_DEST_CRUISES, TRV_DEST_EUROPE, TRV_DEST_EYEBROW,
    TRV_DEST_LATAM, TRV_DEST_OTHER, TRV_DEST_SUBTITLE, TRV_DEST_TITLE, TRV_DEST_USA,
    TRV_PASSPORT_BULLET1, TRV_PASSPORT_BULLET2, TRV_PASSPORT_BULLET3,
    TRV_PASSPORT_CTA, TRV_PASSPORT_EYEBROW, TRV_PASSPORT_SUBTITLE, TRV_PASSPORT_TITLE,
    TRV_BANNER_EYEBROW, TRV_BANNER_SUBTITLE, TRV_BANNER_TITLE,
    TRV_FAQ_A1, TRV_FAQ_A2, TRV_FAQ_A3, TRV_FAQ_A4, TRV_FAQ_A5,
    TRV_FAQ_EYEBROW, TRV_FAQ_Q1, TRV_FAQ_Q2, TRV_FAQ_Q3, TRV_FAQ_Q4, TRV_FAQ_Q5,
    TRV_FAQ_SUBTITLE, TRV_FAQ_TITLE,
    TRV_HELMET_DESCRIPTION, TRV_HELMET_TITLE,
    TRV_HERO_CTA_BOOK, TRV_HERO_CTA_CALL, TRV_HERO_EYEBROW, TRV_HERO_SUBTITLE,
    TRV_HERO_TITLE, TRV_HERO_TITLE_ACCENT,
    TRV_HERO_TRUST_BILINGUAL, TRV_HERO_TRUST_BONDED, TRV_HERO_TRUST_GLOBAL,
    TRV_PROCESS_EYEBROW,
    TRV_PROCESS_STEP1_DESC, TRV_PROCESS_STEP1_TITLE,
    TRV_PROCESS_STEP2_DESC, TRV_PROCESS_STEP2_TITLE,
    TRV_PROCESS_STEP3_DESC, TRV_PROCESS_STEP3_TITLE,
    TRV_PROCESS_STEP4_DESC, TRV_PROCESS_STEP4_TITLE,
    TRV_PROCESS_TITLE,
    TRV_SERVICES_EYEBROW, TRV_SERVICES_SUBTITLE, TRV_SERVICES_TITLE,
    TRV_SERVICE_FLIGHTS_DESC, TRV_SERVICE_FLIGHTS_TITLE,
    TRV_SERVICE_HOTELS_DESC, TRV_SERVICE_HOTELS_TITLE,
    TRV_SERVICE_INSURANCE_DESC, TRV_SERVICE_INSURANCE_TITLE,
    TRV_SERVICE_PACKAGES_DESC, TRV_SERVICE_PACKAGES_TITLE,
    TRV_SERVICE_TRANSPORT_DESC, TRV_SERVICE_TRANSPORT_TITLE,
    TRV_SERVICE_VISA_DESC, TRV_SERVICE_VISA_TITLE,
} from "../types";

const en_travel_page = {
    helmet: {
        [TRV_HELMET_TITLE]: "Travel made simple | Linares Pro Corp",
        [TRV_HELMET_DESCRIPTION]: "Flights, hotels, visas and full travel packages — booked and explained in English or Spanish by a team that has your back before, during, and after the trip.",
    },
    section: {
        hero: {
            [TRV_HERO_EYEBROW]: "Travel services",
            [TRV_HERO_TITLE]: "Your trip,",
            [TRV_HERO_TITLE_ACCENT]: "planned without the stress.",
            [TRV_HERO_SUBTITLE]: "From a quick flight to a full family vacation, we plan, book, and walk you through every step in English or Spanish — so you only worry about packing.",
            [TRV_HERO_CTA_BOOK]: "Plan my trip",
            [TRV_HERO_CTA_CALL]: "Call now",
            [TRV_HERO_TRUST_BONDED]: "Trusted travel partners",
            [TRV_HERO_TRUST_BILINGUAL]: "English & Spanish",
            [TRV_HERO_TRUST_GLOBAL]: "Worldwide destinations",
        },
        services: {
            [TRV_SERVICES_EYEBROW]: "What we book",
            [TRV_SERVICES_TITLE]: "Everything you need for the trip — in one place.",
            [TRV_SERVICES_SUBTITLE]: "We take care of the booking, the paperwork, and the small details so the trip actually feels like a vacation.",
            [TRV_SERVICE_FLIGHTS_TITLE]: "Flights",
            [TRV_SERVICE_FLIGHTS_DESC]: "Domestic and international flights with major airlines, including group, family, and last-minute bookings.",
            [TRV_SERVICE_HOTELS_TITLE]: "Hotels & resorts",
            [TRV_SERVICE_HOTELS_DESC]: "Hotels, all-inclusive resorts, and apartments at competitive rates with the right options for your family.",
            [TRV_SERVICE_VISA_TITLE]: "Travel visas & documents",
            [TRV_SERVICE_VISA_DESC]: "Help preparing visa applications, travel authorizations, and the supporting documents most destinations require.",
            [TRV_SERVICE_INSURANCE_TITLE]: "Travel insurance",
            [TRV_SERVICE_INSURANCE_DESC]: "Coverage options that protect medical emergencies, cancellations, and lost baggage during your trip.",
            [TRV_SERVICE_TRANSPORT_TITLE]: "Ground transport & car rental",
            [TRV_SERVICE_TRANSPORT_DESC]: "Airport transfers, car rentals, and ground transportation coordinated with your itinerary.",
            [TRV_SERVICE_PACKAGES_TITLE]: "Full travel packages",
            [TRV_SERVICE_PACKAGES_DESC]: "Flight + hotel + transfer packages built around your dates, budget, and group size.",
        },
        destinations: {
            [TRV_DEST_EYEBROW]: "Popular destinations",
            [TRV_DEST_TITLE]: "Where do you want to go?",
            [TRV_DEST_SUBTITLE]: "These are the routes we book most often — but if your destination is not here, just ask. We can plan trips almost anywhere.",
            [TRV_DEST_CARIBBEAN]: "Caribbean",
            [TRV_DEST_LATAM]: "Latin America",
            [TRV_DEST_EUROPE]: "Europe",
            [TRV_DEST_USA]: "Within the U.S.",
            [TRV_DEST_CRUISES]: "Cruises",
            [TRV_DEST_OTHER]: "Custom destinations",
        },
        banner: {
            [TRV_BANNER_EYEBROW]: "Wherever you go",
            [TRV_BANNER_TITLE]: "The world is closer than you think.",
            [TRV_BANNER_SUBTITLE]: "From a long weekend in the Caribbean to a family trip across the ocean — we plan it, book it, and stay with you until you are back home.",
        },
        process: {
            [TRV_PROCESS_EYEBROW]: "How it works",
            [TRV_PROCESS_TITLE]: "From idea to boarding pass in four steps.",
            [TRV_PROCESS_STEP1_TITLE]: "Tell us your plan",
            [TRV_PROCESS_STEP1_DESC]: "Dates, destination, travelers, budget — anything you already know. Don't worry if it's not final.",
            [TRV_PROCESS_STEP2_TITLE]: "We send options",
            [TRV_PROCESS_STEP2_DESC]: "We compare prices and routes and send you clear options so you can choose with confidence.",
            [TRV_PROCESS_STEP3_TITLE]: "We book and confirm",
            [TRV_PROCESS_STEP3_DESC]: "Once you approve, we book and send you all the confirmations and travel documents.",
            [TRV_PROCESS_STEP4_TITLE]: "We support you during the trip",
            [TRV_PROCESS_STEP4_DESC]: "If something changes — a delay, a missed connection — we are here to help you fix it.",
        },
        faq: {
            [TRV_FAQ_EYEBROW]: "Travel FAQ",
            [TRV_FAQ_TITLE]: "Common questions before booking.",
            [TRV_FAQ_SUBTITLE]: "Short answers to what most travelers ask us. Anything we missed? Just call.",
            [TRV_FAQ_Q1]: "Is it more expensive to book with you than online?",
            [TRV_FAQ_A1]: "No. We work with the same partners as the big sites, and you get personal support in your language — at no extra cost on most bookings.",
            [TRV_FAQ_Q2]: "Can you help if I have no idea where to go?",
            [TRV_FAQ_A2]: "Yes. Tell us your dates, budget, and what you enjoy and we will send you a few honest options.",
            [TRV_FAQ_Q3]: "Do you help with visas?",
            [TRV_FAQ_A3]: "We help organize, translate, and notarize the documents your destination requires. Final visa approval is up to the consulate.",
            [TRV_FAQ_Q4]: "What if my flight is delayed or canceled?",
            [TRV_FAQ_A4]: "Call or message us. We help you contact the airline, find alternatives, and use your insurance if it applies.",
            [TRV_FAQ_Q5]: "Can I pay in installments?",
            [TRV_FAQ_A5]: "Many of our partners offer installment options for flights and packages. We will let you know what is available when we send your quote.",
        },
        cta: {
            [TRV_CTA_TITLE]: "Ready to start planning?",
            [TRV_CTA_SUBTITLE]: "Send us a quick message or give us a call. We will take it from there.",
            [TRV_CTA_BUTTON]: "Call now",
        },
    },
};

export default en_travel_page;
